import { Informacao } from "components/Informacao";
import { ModalCustom } from "components/ModalCustom";
import {
  EspacoAntesDoRodape,
  LarguraModal,
  Pergunta,
  TextoInfo,
} from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  porSelecao: boolean;
  quantidadeElegivel: number;
  onConfirmar: () => Promise<boolean>;
  carregando: boolean;
}

export function ReprocessarModal({
  show,
  handleClose,
  porSelecao,
  quantidadeElegivel,
  onConfirmar,
  carregando,
}: IProps) {
  const escopo = porSelecao ? "selecionadas" : "desta página";

  async function confirmar() {
    if (await onConfirmar()) {
      handleClose();
    }
  }

  return (
    <>
      <LarguraModal />
      <ModalCustom
        show={show}
        handleClose={carregando ? () => {} : handleClose}
        title="Reprocessar"
        dialogClassName="modal-reprocessar"
        centered
        footer
        footerConfirmButton
        onConfirm={confirmar}
        disabledConfirmButton={carregando || !quantidadeElegivel}
      >
        <Pergunta>
          Deseja reprocessar as placas com status de falha autorização?
        </Pergunta>
        <EspacoAntesDoRodape>
          <Informacao
            type={quantidadeElegivel ? "info" : "atencao"}
            showLabel={false}
            showBotaoFechar={false}
            mensagem={
              quantidadeElegivel ? (
                <TextoInfo>
                  Serão reprocessadas{porSelecao ? "" : " todas"} as placas{" "}
                  <strong>{escopo}</strong> com status de falha autorização.
                  Exceto os registros que já possuem id autorização.
                </TextoInfo>
              ) : (
                <TextoInfo>
                  Não há placas <strong>{escopo}</strong> com status de falha
                  autorização para reprocessar.
                </TextoInfo>
              )
            }
          />
        </EspacoAntesDoRodape>
      </ModalCustom>
    </>
  );
}
